// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ShareRoundSvg from '@rsuite/icon-font/lib/action/ShareRound';
var ShareRound = createSvgIcon({
  as: ShareRoundSvg,
  ariaLabel: 'share round',
  category: 'action',
  displayName: 'ShareRound'
});
export default ShareRound;